<script setup>
import { useI18n } from 'vue-i18n'
import { router } from '@inertiajs/vue3'
import UiButton from '@/Components/UI/UiButton.vue'
import ContactPanel from './ContactPanel.vue'
import ActiveRental from './ActiveRental.vue'
import RecentRentals from './RecentRentals.vue'
import NotesPanel from './NotesPanel.vue'
import ActivityPanel from './ActivityPanel.vue'

const props = defineProps({
  conversation: { type: Object, required: true },
})

const { t } = useI18n()

const createRental = () => {
  if (!props.conversation.customer) return
  const returnTo = encodeURIComponent(`/inbox/conversations/${props.conversation.id}`)
  router.visit(`/rentals/new?customer_id=${props.conversation.customer.id}&return_to=${returnTo}`)
}
</script>

<template>
  <aside class="border-l border-[color:var(--line)] bg-[color:var(--surface)] overflow-y-auto p-4 space-y-4">
    <ContactPanel :conversation="conversation" />
    <ActiveRental v-if="conversation.active_rental"
                  :rental="conversation.active_rental"
                  :conversation-id="conversation.id" />
    <RecentRentals v-if="conversation.customer"
                   :rentals="conversation.customer.recent_rentals || []" />
    <UiButton v-if="conversation.contact_kind !== 'vehicle_source'"
              variant="primary"
              icon-left="rental"
              :disabled="!conversation.customer || !conversation.taken_at"
              :title="!conversation.taken_at ? t('inbox.thread.takeFirst') : null"
              class="w-full"
              @click="createRental">
      {{ t('inbox.drawer.createRental') }}
    </UiButton>
    <NotesPanel :conversation-id="conversation.id"
                :notes="conversation.notes || []"
                :taken="!!conversation.taken_at" />
    <ActivityPanel :events="conversation.events || []" />
  </aside>
</template>
